import React, { useEffect, useState } from 'react'
import { validateFunctionalForm } from '../../../utils';
import { v2_transporters } from '../../../actions/v2/transporter';

const Form = (props) => {

    const [state, setState] = useState({
        name: { name: 'name', value: props.data ? props.data.NAME : '', isRequired: true, error: '' },
        vehicleNumber: { name: 'vehicleNumber', value: props.data ? props.data.VEHICLE_NUMBER : '', isRequired: true, error: '' },
        otherDetails: { name: 'otherDetails', value: props.data ? props.data.DETAIL : '', isRequired: false, error: '' },
        transporter: { name: 'transporter', value: props.data ? props.data.TRANSPORTER_ID : '', options: [], isRequired: false, error: '' },

    });

    useEffect(() => {
        v2_transporters().then((res) => {
            if (res.status) {
                setOptions('transporter', res.result);
            }
        })
    }, [])

    const onChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: value,
                error: prevState[name].isRequired && !value ? 'This field is required' : ''
            }
        }));
    };

    const setOptions = (name, options) => {
        setState(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                options: options
            }
        }));
    };


    const onSubmit = (e) => {
        e.preventDefault();
        if (validateFunctionalForm(state, setState)) {
            const model = {
                vehicleName: state.name.value,
                otherDetails: state.otherDetails.value,
                vehicleNumber: state.vehicleNumber.value,
                transporterId: state.transporter.value
            }
            if (props.data) {
                model.id = props.data.ID
            }
            props.onSubmit(model)
        }
    }
    return (
        <React.Fragment>
            <h4 className="card-title mb-4">{props.title}</h4>
            <div id="basic-example">
                <section>
                    <form onSubmit={onSubmit}>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-Transporter-input">
                                        Transporter <span className='text-danger'>*</span>
                                    </label>
                                    <select
                                        className={state.transporter.error ? "form-select is-invalid" : "form-select"}
                                        id="basicpill-Transporter-input"
                                        name={state.transporter.name}
                                        value={state.transporter.value}
                                        onChange={onChange}
                                    >
                                        <option value={''}> Select Transporter</option>
                                        {state.transporter.options.map((item) => {
                                            return (<option value={item.ID}> {item.NAME}</option>)
                                        })}
                                    </select>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-firstname-input">
                                        Vehicle Name <span className='text-danger'>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={state.name.error ? "form-control is-invalid" : "form-control"}
                                        id="basicpill-firstname-input"
                                        placeholder="Enter Gate Name"
                                        name={state.name.name}
                                        value={state.name.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-vehicleNumber-input">
                                        Vehicle Number <span className='text-danger'>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className={state.vehicleNumber.error ? "form-control is-invalid" : "form-control"}
                                        id="basicpill-vehicleNumber-input"
                                        placeholder="Enter Vehicle Number"
                                        name={state.vehicleNumber.name}
                                        value={state.vehicleNumber.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-12">
                                <div className="mb-3">
                                    <label htmlFor="basicpill-address-input">
                                        Other Details
                                    </label>
                                    <textarea
                                        id="basicpill-address-input"
                                        className={state.otherDetails.error ? "form-control is-invalid" : "form-control"}
                                        rows={2}
                                        placeholder="Enter Other Details"
                                        defaultValue={""}
                                        name={state.otherDetails.name}
                                        value={state.otherDetails.value}
                                        onChange={onChange}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="mb-3">
                                    <button
                                        type='submit'
                                        className="btn btn-success waves-effect btn-label waves-light me-2"
                                    >
                                        <i className="bx bx-check-double label-icon" />{" "}
                                        {props.buttonName}
                                    </button>
                                    <button
                                        type='reset'
                                        onClick={() => { props.onCancel() }}
                                        className="btn btn-danger waves-effect btn-label waves-light"
                                    >
                                        <i className="bx bx-block label-icon " /> Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div>
        </React.Fragment>

    )
}

export default Form